<template>
  <Modal :show="show" class-name="recall-modal-container" @close="close">
    <div class="modal-main">
      <div class="modal-header">
        <h2 class="modal-title">Recall Report</h2>
      </div>
      <div class="modal-body">
        <p class="recall-note">
          <strong>Please provide the reason why the report needs to be recalled.</strong><br />
          (Note the reason provided will be visible to the practitioner and patient)
        </p>

        <b-form-group label="Reason for Recall" label-for="recallReason">
          <b-form-textarea
            id="recallReason"
            v-model="recallReason"
            v-validate="'required|max:250'"
            name="recallReason"
            :class="{ 'is-invalid': errors.has('recallReason') }"
            rows="4"
            placeholder="Enter reason for recall..."
          />
          <div
            v-if="errors.has('recallReason')"
            class="invalid-feedback"
            :class="{ 'd-block': errors.has('recallReason') }"
          >
            {{ errors.first('recallReason') }}
          </div>
          <small class="text-muted"> {{ recallReason.length }}/250 characters </small>
        </b-form-group>

        <div v-if="localError" class="alert alert-danger">
          {{ localError }}
        </div>

        <div class="d-flex justify-content-between">
          <Button text="Recall Report" :saving="loading" :success="buttonSuccess" @onClick="onClickSave" />
          <Button text="Cancel" @onClick="close" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/models/Modal'
  import Button from '@/components/elements/DynamicButton'

  export default {
    name: 'ModalRecallReason',
    components: { Modal, Button },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        buttonSuccess: false,
        localError: null,
        recallReason: ''
      }
    },
    watch: {
      show(val) {
        if (val === true) {
          this.resetForm()
        }
      }
    },
    methods: {
      close() {
        this.$emit('update:show', false)
      },

      resetForm() {
        this.recallReason = ''
        this.localError = null
        this.buttonSuccess = false

        // Clear validation errors
        if (this.$validator) {
          this.$validator.reset()
        }
      },

      onClickSave: function () {
        this.localError = null

        this.$validator.validate().then(() => {
          if (this.errors.any()) {
            this.localError = 'Please fill out or correct the highlighted fields'
            return
          }

          // Emit the recall reason to parent
          this.$emit('confirm', {
            reason: this.recallReason.trim()
          })
          this.$emit('update:show', false)
        })
      }
    }
  }
</script>

<style>
  /* Override global modal container styles for this specific modal */
  .recall-modal-container {
    max-width: 420px !important;
    width: auto !important;
    height: auto !important;
    padding: 0 !important;
    margin: 20px !important;
    justify-content: flex-start !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }

  /* Modal Content */
  .recall-modal-container .modal-main {
    background: white;
    border-radius: 8px;
    padding: 24px;
    width: 100%;
    margin: 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  /* Header */
  .recall-modal-container .modal-header {
    margin-bottom: 20px;
    text-align: left;
  }

  .recall-modal-container .modal-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
  }

  /* Body */
  .recall-modal-container .modal-body {
    padding: 0;
  }

  .recall-modal-container .recall-note {
    margin-bottom: 20px;
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.4;
  }

  /* Form Elements */
  .recall-modal-container .form-group {
    margin-bottom: 20px;
  }

  .recall-modal-container .invalid-feedback.d-block {
    display: block !important;
  }

  /* Button Container */
  .recall-modal-container .d-flex {
    margin-top: 24px;
    gap: 12px;
  }

  .recall-modal-container .btn {
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 6px;
  }

  /* Responsive Design */
  @media (max-width: 480px) {
    .recall-modal-container {
      max-width: calc(100% - 20px) !important;
      margin: 10px !important;
    }

    .recall-modal-container .modal-main {
      padding: 20px;
    }

    .recall-modal-container .d-flex {
      flex-direction: column;
    }

    .recall-modal-container .btn {
      width: 100%;
      margin-bottom: 8px;
    }
  }
</style>
